import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const roadFilterMain = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredFeatures, allFeatures) => {
            return allFeatures.filter((feature) => {
                const props = feature.properties;
                return (
                    filteredFeatures.includes(feature) ||
                    (!props.isFuture && ((props.messageType && props.messageType !== 'Vägarbete') || props.severity === 5))
                );
            });
        },
    };

    return new FilterLayer('road-filter-main', layers, { ...defaultOptions, ...options });
};
